/* ═══════════════════════════════════════
   COCCINUT — coccinut.js
   Shopify Theme · iOS / Android
═══════════════════════════════════════ */

(function () {
  'use strict';

  /* ── NAVBAR : scroll effect ── */
  var nav = document.getElementById('nav');
  if (nav) {
    var onScroll = function () {
      nav.classList.toggle('sc', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── MENU MOBILE ── */
  var mob  = document.getElementById('mob');
  var ham  = document.getElementById('ham');
  var mobX = document.getElementById('mob-x');

  function openMob() {
    if (!mob) return;
    mob.classList.add('open');
    ham && ham.classList.add('open');
    document.body.style.overflow  = 'hidden';
    document.body.style.position  = 'fixed';
    document.body.style.width     = '100%';
    mob.setAttribute('aria-hidden', 'false');
    ham && ham.setAttribute('aria-expanded', 'true');
  }

  function closeMob() {
    if (!mob) return;
    mob.classList.remove('open');
    ham && ham.classList.remove('open');
    document.body.style.overflow  = '';
    document.body.style.position  = '';
    document.body.style.width     = '';
    mob.setAttribute('aria-hidden', 'true');
    ham && ham.setAttribute('aria-expanded', 'false');
  }

  function toggleMob() {
    mob && mob.classList.contains('open') ? closeMob() : openMob();
  }

  if (ham)  ham.addEventListener('click', toggleMob);
  if (mobX) mobX.addEventListener('click', closeMob);

  if (mob) {
    mob.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeMob);
    });
    mob.addEventListener('click', function (e) {
      if (e.target === mob) closeMob();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMob();
  });

  window.toggleMob = toggleMob;
  window.closeMob  = closeMob;

  /* ── SCROLL REVEAL ── */
  function initReveal() {
    if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) {
      document.querySelectorAll('.rv').forEach(function (el) {
        el.classList.add('up');
      });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('up');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.07 });

    document.querySelectorAll('.rv').forEach(function (el) {
      obs.observe(el);
    });
  }

  /* ── FAQ ACCORDION ── */
  function initFaq() {
    document.querySelectorAll('.faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var ans  = btn.nextElementSibling;
        var tog  = btn.querySelector('.faq-tog');
        var open = ans && ans.classList.contains('op');

        document.querySelectorAll('.faq-ans').forEach(function (a) { a.classList.remove('op'); });
        document.querySelectorAll('.faq-tog').forEach(function (t) { t.classList.remove('op'); t.textContent = '+'; });

        if (!open && ans) {
          ans.classList.add('op');
          tog && tog.classList.add('op');
        }
      });
    });
  }

  /* ── ACTIVE NAV LINK ── */
  function setActiveNav() {
    var path = window.location.pathname;
    document.querySelectorAll('.nl a, .mob-links a').forEach(function (a) {
      a.classList.remove('act');
      var href = a.getAttribute('href') || '';
      if (
        (path === '/' && (href === '/' || href === '/index.html')) ||
        (path !== '/' && href !== '/' && path.indexOf(href) === 0)
      ) {
        a.classList.add('act');
      }
    });
  }

  /* ── STAT COUNTERS ── */
  function initCounters() {
    var els = document.querySelectorAll('.stat-n');
    if (!els.length || window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);
        var el = entry.target;
        var raw = el.textContent.trim();
        var match = raw.match(/^(\d+\.?\d*)/);
        if (!match) return;
        var target = parseFloat(match[1]);
        var isFloat = raw.indexOf('.') !== -1;
        var suffix = raw.slice(match[0].length);
        var duration = 1400;
        var startTime = null;
        function tick(now) {
          if (!startTime) startTime = now;
          var p = Math.min((now - startTime) / duration, 1);
          var ease = 1 - Math.pow(1 - p, 3);
          el.textContent = (isFloat ? (target * ease).toFixed(1) : Math.round(target * ease)) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ── 3D BOX VIEWER ANIMATION ── */
  function initBoxViewer() {
    if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    var viewers = document.querySelectorAll('.mv-box');
    if (!viewers.length) return;

    viewers.forEach(function (viewer) {
      var t = 0;
      var paused = false;
      var resumeTimer = null;

      viewer.addEventListener('pointerdown', function () {
        paused = true;
        clearTimeout(resumeTimer);
      });

      function resume() {
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () { paused = false; }, 1200);
      }
      viewer.addEventListener('pointerup', resume);
      viewer.addEventListener('pointerleave', resume);

      function tick() {
        if (!paused) {
          t += 0.007;
          var theta = 90 + Math.sin(t) * 20;
          var phi   = 82 + Math.sin(t * 0.6) * 3;
          viewer.setAttribute('camera-orbit', theta.toFixed(2) + 'deg ' + phi.toFixed(2) + 'deg 105%');
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }

  /* ── HERO PARALLAX ── */
  function initHeroParallax() {
    var badge = document.querySelector('.h-badge');
    var hero  = document.querySelector('.hero');
    if (!badge || !hero || window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > hero.offsetHeight) return;
      badge.style.transform = 'translateY(calc(-50% + ' + (y * 0.1) + 'px))';
    }, { passive: true });
  }

  /* ── INIT ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
      initFaq();
      setActiveNav();
      initCounters();
      initHeroParallax();
      initBoxViewer();
    });
  } else {
    initReveal();
    initFaq();
    setActiveNav();
    initCounters();
    initHeroParallax();
    initBoxViewer();
  }

  /* ── MOBILE SECTION TRANSITIONS ── */
  if (window.innerWidth <= 768 && !window.matchMedia('(prefers-reduced-motion:reduce)').matches) {
    document.querySelectorAll('section, .stat-bar, .band').forEach(function (el) {
      el.classList.add('sec-mob');
    });
    var secObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          secObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.sec-mob').forEach(function (el) { secObs.observe(el); });
  }

})();
